import { render, staticRenderFns } from "./ChartOfAccountTypeForm.vue?vue&type=template&id=626f1e38&"
import script from "./ChartOfAccountTypeForm.vue?vue&type=script&lang=js&"
export * from "./ChartOfAccountTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports